var exports = {
  "Dk": "xfd349460--9f9627--carousel",
  "Qs": "xfd349460--9f9627--content",
  "UE": "xfd349460--9f9627--arrow",
  "m0": "xfd349460--9f9627--arrow-left",
  "tS": "xfd349460--9f9627--arrow-right",
};

module.exports = exports;
